"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteService = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var EqualityComparers_1 = require("icf-search-client-shared/lib/EqualityComparers");
var AutocompleteService = /** @class */ (function () {
    function AutocompleteService(apiClientFactory) {
        this._clientFactory = apiClientFactory;
        this._client = apiClientFactory.createClient();
        // TODO: Need to avoid memory leak. LRUCache could achieve that. Temp cache limit enforced in getItems
        this._cache = new Map();
    }
    AutocompleteService.prototype.getItems = function (queryOptions, sakey, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, results, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.query) || queryOptions.query.length === 0) {
                            return [2 /*return*/];
                        }
                        // if the sakey has changed, then we need to remake the client so that it picks up the changed sakey
                        if (sakey !== this._sakey) {
                            this._client = this._clientFactory.createClient();
                            this._sakey = sakey;
                        }
                        cacheKey = JSON.stringify(queryOptions);
                        results = this._cache.get(cacheKey);
                        if (results) {
                            callback(results);
                            // Clear any outstanding callback.
                            this._callback = undefined;
                            return [2 /*return*/];
                        }
                        // TODO: Q: Will there ever be a time when we care about anything but the most recent callback?
                        this._callback = callback;
                        // TODO: Verify that this makes sense.
                        if ((0, EqualityComparers_1.deepEqualityComparer)(queryOptions, this._pendingQuery)) {
                            // This was a redundant call while things are already in flight.
                            return [2 /*return*/];
                        }
                        this._pendingQuery = queryOptions;
                        return [4 /*yield*/, this._client.getAutocomplete(queryOptions)];
                    case 1:
                        response = _a.sent();
                        // TODO: Remove temp cache when this._cache takes care of that.
                        // Here is a temporary memory leak protector:
                        /* istanbul ignore if  */
                        if (this._cache.size > 10) {
                            // Overly harsh to just clear.
                            /* istanbul ignore next */
                            this._cache.clear();
                        }
                        this._cache.set(cacheKey, response.results);
                        if (!(0, EqualityComparers_1.deepEqualityComparer)(queryOptions, this._pendingQuery)) {
                            return [2 /*return*/];
                        }
                        // Now that the request is fulfilled, we can remove the pending query.
                        this._pendingQuery = undefined;
                        this._callback(response.results);
                        return [2 /*return*/];
                }
            });
        });
    };
    return AutocompleteService;
}());
exports.AutocompleteService = AutocompleteService;
//# sourceMappingURL=AutocompleteService.js.map